/** @module store/energy_management_system_groups */

import * as actions from '@/store/modules/energy_management_system_groups/actions'
import * as getters from '@/store/modules/energy_management_system_groups/getters'
import * as mutations from '@/store/modules/energy_management_system_groups/mutations'

/**
 * Store state for current `energy_management_system_groups`.
 *
 * - {object} EnergyManagementSystemGroup, defined by at least an {integer|id} and a {string|name}
 *
 * state.emsGroups.hash[emsGroupId] => {object} includes all the EmsGroup information for the EmsGroup with the ID emsGroupId, e.g name
 *
 * state.emsGroups.hierarchy => {object} showing the relation between groups in a tree structure. {groupID}->{childrenIds}
 *
 * state.emss[emsId] => Array[Integer] includes the emsGroupIds that are related to the EMS with the ID emsId
 *
 * state.users[userId] => Array[Integer] includes the emsGroupIds that are related to the User with the ID userId
 *
 * @function
 *
 * @return {object}
 */

const state = () => ({
  emss: {},
  emsGroups: {
    hash: {},
    hierarchy: {}
  },
  users: {}
})

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

/**
 * A EMS Group data-struct.
 *
 * @constructor
 *
 * @param {object} params
 * @param {string|integer} params.id is the groups's ID
 * @param {string} params.name is the group's name returned from the BE. Will be used as fallback, if `displayName` is blank.
 * @param {string} params.displayName is the group's display name returned from the BE. Will be stored as `name`.
 * @param {integer} params.parentId is th group's parent's ID
 * @param {string} params.tag groups tag for Groups::CommunityGroup
 *
 */
export function EmsGroup({ id, name, displayName, parentId, tag = null }) {
  if (!name) {
    throw TypeError('Missing or invalid name.')
  }

  this.id = parseInt(id)
  this.name = displayName || name
  this.parentId = parentId ? parseInt(parentId) : null
  this.tag = tag
}
